import { createSlice } from "@reduxjs/toolkit";


export const searchTextSlice = createSlice({
  name: "searchValue",
  initialState: {
    searchText:""
  },
  reducers: {
    setSearchTextGlobal: (state, { payload }) => {
      return {
        searchText: payload.searchText,
      };
    },
  },
});
export const { setSearchTextGlobal } = searchTextSlice.actions;

export const filterListDataSlice = createSlice({
  name: "filteredList",
  initialState: {
    filteredListType: ""
  },
  reducers: {
    setFilteredData: (state, { payload }) => {
      return {
        filteredListType:payload.filteredListType
      }
    },
  },
});

export const { setFilteredData } = filterListDataSlice.actions;

export const currencyInvoiceDataSlice = createSlice({
  name: "currency",
  initialState: {
    currencyCode: "INR"
  },
  reducers: {
    setCurrency: (state, { payload }) => {
      return {
        currencyCode:payload.currencyCode
      }
    },
  },
});

export const { setCurrency } = currencyInvoiceDataSlice.actions;
